import { useState } from 'react'
import useAlert from '../../../components/Alert/hooks/useAlert'
import batchUploadCsv from '../repository/batchUploadCsv'

const useBatchUploader = () => {
  const [uploading, setUploading] = useState(false)
  const { alertSuccess, alertError } = useAlert()

  const uploadTrackingNumbers = async (file: File, disableEmail: boolean) => {
    setUploading(true)
    const result = await batchUploadCsv({ file, disableEmail })
    setUploading(false)

    if (result.error) {
      alertError(result.error)
      return
    }

    alertSuccess('File uploaded successfully')
  }

  return {
    uploading,
    uploadTrackingNumbers
  }
}

export default useBatchUploader
